<template>
  <div class="user-list-item" @click="openUser">

      <div class=" left-data">
        <div class="left-data__photo">
          <letters-avatar :name="user.name" type="mini" />
        </div>
        <div class="user-data">
          <div class="user-data__name">{{ user.name }}</div>
          <div class="user-data__phone">{{ user.phone }}</div>
        </div>
      </div>
      <div class="right-data">
        id {{ user.id }}
      </div>

    </div>

</template>

<script>
import LettersAvatar from "@/components/elements/LettersAvatar";

export default {
  name: "UserListItem",
  components: { LettersAvatar },
  props: {
    user: {},
  },
  data: () => {
    return {};
  },
  computed: {},
  methods: {
    openUser() {
      this.$emit("openUser", this.user);
    },
    tagColor(id) {
      let colors = [
        "#FFC839",
        "#32e66e",
        "#82bcfc",
        "#9ab326",
        "#efb237",
        "#e64132",
        "#8632e6",
        "#e632b3",
        "#32e6b3",
        "#74aeec",
      ];
      let color = id % colors.length;
      return colors[color];
    },
  },
};
</script>

<style scoped lang="scss">
.user-list-item {

  padding: 10px 16px;

  background: #fff;

  align-self: flex-start;
  display: flex;
  justify-content: space-between;

  transition: all 0.3s ease;
  cursor: pointer;
  align-items: center;
  color: #8c8c8c;

  &:hover {
    background: rgba(67, 211, 179, 0.05)!important;

    border-radius: 6px;
  }
}

.user-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;


  .left-data {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__photo {
      height: 40px;
      margin-right: 16px;
    }

    .user-data {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      font-size: 15px;
      line-height: 16px;
      color: #111;

      &__name {
        font-weight: 600;
      }

      &__phone {
        margin-left: 8px;

      }
    }
  }
}

.right-data {
  margin-left: 24px;
  font-size: 15px;
  line-height: 16px;


  color: #8E8E93;

}

</style>
